/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.2.6
* 
*******************************************************************************/
import core from"./core";import util from"./util";export default function detect(r,t){let e=util.isFunction,o=core.userAgent;return!(!e(t)||!t())||!(!core.isBrowser()||!o)&&(e(r)&&r(o))}